import clsx from "clsx";

export const icons = {
  "approved-doc": "/assets/icons/Icon-approved-doc.png",
  approved: "/assets/icons/Icon-approved.png",
  bank: "/assets/icons/Icon-bank.png",
  datastream: "/assets/icons/Icon-datastream.png",
  documents: "/assets/icons/Icon-documents.png",
  "done-document": "/assets/icons/Icon-done-document.png",
  done: "/assets/icons/Icon-done.png",
  handover: "/assets/icons/Icon-handover.png",
  key: "/assets/icons/Icon-key.png",
  lock: "/assets/icons/Icon-lock.png",
  map: "/assets/icons/Icon-map.png",
  money: "/assets/icons/Icon-money.png",
  phone: "/assets/icons/Icon-phone.png",
  safe: "/assets/icons/Icon-safe.png",
  signature: "/assets/icons/Icon-signature.png",
  stop: "/assets/icons/Icon-stop.png",
  trash: "/assets/icons/Icon-trash.png",
} as const;

export type IconId = keyof typeof icons;

type Props = Omit<React.ComponentProps<"img">, "src" | "width" | "height"> & {
  icon: IconId;
  size?: number;
};

export function PixelIcon({ className, icon, size = 24, alt, ...imageProps }: Props) {
  return (
    <img
      {...imageProps}
      className={clsx(className, "u-pixel-art")}
      src={icons[icon]}
      width={size}
      height={size}
      alt={alt ?? ""}
    />
  );
}
